/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as operations from "./operations";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import { IdentityRestClientContext } from "./identityRestClientContext";
import { IdentityRestClientOptionalParams } from "./models";

class IdentityRestClient extends IdentityRestClientContext {
  /**
   * Initializes a new instance of the IdentityRestClient class.
   * @param endpoint The communication resource, for example https://my-resource.communication.azure.com
   * @param options The parameter options
   */
  constructor(endpoint: string, options?: IdentityRestClientOptionalParams) {
    super(endpoint, options);
    this.communicationIdentity = new operations.CommunicationIdentity(this);
  }

  communicationIdentity: operations.CommunicationIdentity;
}

// Operation Specifications

export {
  IdentityRestClient,
  IdentityRestClientContext,
  Models as IdentityRestModels,
  Mappers as IdentityRestMappers
};
export * from "./operations";
